import { render, staticRenderFns } from "./LoyaltyProductBlock.vue?vue&type=template&id=f70f97da&scoped=true&"
import script from "./LoyaltyProductBlock.vue?vue&type=script&lang=js&"
export * from "./LoyaltyProductBlock.vue?vue&type=script&lang=js&"
import style0 from "./LoyaltyProductBlock.vue?vue&type=style&index=0&id=f70f97da&prod&lang=scss&scoped=true&"
import style1 from "./LoyaltyProductBlock.vue?vue&type=style&index=1&id=f70f97da&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../nodevenv/public_html/de.jeanmarcphilippe.com/shop.digipart.fr/16/lib/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f70f97da",
  null
  
)

export default component.exports